// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__1hOL9","triangle":"Loader_triangle__21mm9","follow":"Loader_follow__2v1zk"};